import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, copyTextToClipboard, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { razorpayDisconnect } from 'modules/profile/payment-gateways/integrations/razorpay/api';
import RazorpayCreateModal from 'modules/profile/payment-gateways/integrations/razorpay/components/razorpay-create-modal';
import { RazorPayPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/razorpay/types';
import { getRazorpayHelpPageLink } from 'modules/profile/payment-gateways/integrations/razorpay/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, CopyIcon, RazorpayLogoIcon } from '@systemeio/ui/icons';
export const Razorpay: FC = () => {
  const $ = _c(11);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.Razorpay
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const razorpayIntegration = t0;
  let t1;
  if ($[2] !== deleteOpened || $[3] !== razorpayIntegration || $[4] !== removePaymentIntegration || $[5] !== t || $[6] !== user?.dashboardLocale) {
    const title = getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay);
    const onDelete = async () => {
      await razorpayDisconnect();
      await removePaymentIntegration({
        processor: PaymentProcessorEnum.Razorpay
      });
      toast.success(t("dashboard.settings.payment-gateways.account_removed", {
        payment: title
      }));
    };
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <RazorpayLogoIcon />;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    const t3 = user?.dashboardLocale;
    let t4;
    if ($[9] !== t3) {
      t4 = getRazorpayHelpPageLink(t3);
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t1 = <Integration logo={t2} additionalInfo={<a className="primary-link" href={t4} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
        integration: title
      }} /></a>}>{razorpayIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!razorpayIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}<p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.api_key_id")}:`}</span><span className="text-text-primary truncate">{razorpayIntegration.details.apiKeyId}</span></p><div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.webhook_url")}:`}</span><span className="text-text-primary truncate">{razorpayIntegration.details.webhookUrl}</span><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
                await copyTextToClipboard(razorpayIntegration.details.webhookUrl, t("global.copy_clipboard"));
              }} className="group outline-hidden"><CopyIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer sm:h-[20px] sm:w-[20px]" /></button></Tooltip></div><div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.webhook_secret")}:`}</span><span className="text-text-primary truncate">{razorpayIntegration.details.webhookSecret}</span><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
                await copyTextToClipboard(razorpayIntegration.details.webhookSecret || "", t("global.copy_clipboard"));
              }} className="group outline-hidden"><CopyIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer sm:h-[20px] sm:w-[20px]" /></button></Tooltip></div></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
          payment: title
        })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
          payment: title
        })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.razorpay")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <RazorpayCreateModal />}</Integration>;
    $[2] = deleteOpened;
    $[3] = razorpayIntegration;
    $[4] = removePaymentIntegration;
    $[5] = t;
    $[6] = user?.dashboardLocale;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};